import * as React from 'react';
import cx from 'classnames';

import DropdownCore from '@common/containers/fields/Dropdown';
import { TABLE_FIELD_FILTER_TYPE } from '../../../../Table.constants';

import './dropdown.styles.scss';

export const Dropdown = (props) => {
  const { value, className, options, metadata, onSave, moduleName, type } = props;

  const handleChange = React.useCallback((selectedValue) => {
    const result = type === TABLE_FIELD_FILTER_TYPE.integer ? options.findIndex((x) => x == selectedValue) : selectedValue;

    onSave({
      value: result,
      metadata,
    });
  }, [onSave, metadata, options]);

  const processedOptions = React.useMemo(() => {
    if (options.includes('')) {
      return options;
    }

    return [
      '',
      ...options
    ];
  }, [options]);

  const getValue = () => {
    if (type === TABLE_FIELD_FILTER_TYPE.integer) {
      return options[value];
    }

    return value;
  };

  const finalValue = getValue() ?? '';

  return (
    <DropdownCore
      fullWidth
      id={`${moduleName}-dropdown--filter`}
      className={cx('TableDropdown', className)}
      selectedValue={finalValue}
      searchable={false}
      options={processedOptions}
      optionsHeight={200}
      onValueChanged={handleChange}
    />
  );
};

Dropdown.defaultProps = {
  options: [],
};